<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    fill="none"
    viewBox="0 0 20 20"
  >
    <g
      stroke="#fff"
      stroke-linecap="square"
      stroke-width="2"
      clip-path="url(#a)"
    >
      <path d="M1 1h18M1 10h18M1 19h18" />
    </g>
    <defs>
      <clipPath id="a"><path fill="#fff" d="M0 0h20v20H0z" /></clipPath>
    </defs>
  </svg>
</template>
